module.exports = __webpack_public_path__ + "img/30.c3dd3d9a.jpg";